var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("tr", { staticClass: "table-people__row" }, [
    _c("td", { staticClass: "table-people__cell" }, [
      _vm._v(_vm._s(_vm.person.id))
    ]),
    _vm._v(" "),
    _c("td", { staticClass: "table-people__cell" }, [
      _vm._v(_vm._s(_vm.person.firstName))
    ]),
    _vm._v(" "),
    _c("td", { staticClass: "table-people__cell" }, [
      _vm._v(_vm._s(_vm.person.lastName))
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-45e7580a", { render: render, staticRenderFns: staticRenderFns })
  }
}